export default {
  name: 'RenderRow',
  functional: true,
  props: {
    row: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: function () {
        return {}
      }
    },
    render: Function
  },
  render: (h, ctx) => {
    const params = {
      row: ctx.props.row
    }
    return ctx.props.render(h, params)
  }
}



// WEBPACK FOOTER //
// ./src/cdpBase/baseComponents/table/src/renderRow.js